import React from 'react';

// Import images
import coswanHero from "../assets/img/Coswan-hero.png";
import b2bProduct1 from "../assets/img/b2b-Product-1.png";
import b2bProduct2 from "../assets/img/b2b-Product-2.png";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';

const B2BProduct = () => {
  return (
    <div>
        <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Products</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
            <li className="breadcrumb-item"><a href="#">E-Commerce</a></li>
            <li className="breadcrumb-item active text-primary">B2B Products</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-yellow-light p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-4 col-lg-4">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={coswanHero}
                    className="img-fluid rounded w-45"
                    alt="b2b Vendor Product Screen"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-8 col-lg-8 p-5">
              <h1>Transform Your Business with a Scalable B2C Ecosystem</h1>
              <p className="font-size-p">
                At Epic-X we offer next-generation B2C eCommerce solutions designed to streamline customer ordering, product management, and last-mile delivery. With AI-driven insights, real-time analytics, and seamless third-party integrations, businesses can enhance efficiency, improve decision-making, and provide a superior customer experience.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-8 col-lg-8 p-5">
              <h1>Key Features of Our B2C Ecosystem</h1>
              <ul className="list-unstyled">
                <li><span className="icon-box"></span> User-Friendly & Intuitive Interface – A smooth and engaging shopping experience.</li>
                <li><span className="icon-box"></span> Smart Search & Voice Ordering – AI-enhanced search suggestions, filters, and voice-enabled ordering.</li>
                <li><span className="icon-box"></span> Secure Multi-Payment Gateway Integration – Supports UPI, Wallets, Credit/Debit Cards, PayPal, Stripe, Razorpay, and BNPL (Buy Now Pay Later).</li>
                <li><span className="icon-box"></span> Real-Time Order Tracking & Notifications – Live status updates via SMS, push notifications, and WhatsApp alerts.</li>
                <li><span className="icon-box"></span> Loyalty & Rewards Program – AI-driven personalized offers, discounts, and cashback incentives.</li>
                <li><span className="icon-box"></span> Live Order Tracking & Status Updates – Provides customers with accurate ETAs and SMS notifications.</li>
              </ul>
            </div>
            <div className="col-md-4 col-lg-4">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={b2bProduct1}
                    className="img-fluid rounded w-45"
                    alt="Business 2 Business"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-4 col-lg-4">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={b2bProduct2}
                    className="img-fluid rounded w-45"
                    alt="Business 2 Business"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-8 col-lg-8 p-5">
              <h1>Vendor & Product Management System</h1>
              <ul className="list-unstyled">
                <li><span className="icon-box"></span> Centralized Vendor Dashboard – Manage inventory, pricing, and product listings efficiently.</li>
                <li><span className="icon-box"></span> AI-Powered Stock Replenishment – Intelligent alerts for low stock and automated restocking recommendations.</li>
                <li><span className="icon-box"></span> Multi-Vendor Marketplace Support – Seamlessly onboard and manage multiple vendors.</li>
                <li><span className="icon-box"></span> Dynamic Pricing & Demand Forecasting – AI-driven insights to optimize pricing strategies.</li>
                <li><span className="icon-box"></span> Product Performance Insights – Analyze top-selling items, seasonal trends, and customer preferences.</li>
                <li><span className="icon-box"></span> Real-Time Sales & Revenue Reports – AI-powered analytics for sales tracking and revenue growth.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}
      <Footer/>
    </div>
  );
};

export default B2BProduct;